/**
 * © 2025 Little Shilling, Inc.
 * Shon Little
 * Created: 2025-09-30
 */

/**
 * Determines the API base URL based on the current hostname
 * Uses test API for test/staging domains, production API otherwise
 */
const getApiBaseUrl = (): string => {
  // If we're on a test domain, use test API
  if (
    window.location.hostname.includes('test') ||
    window.location.hostname.includes('staging')
  ) {
    return 'https://test.api.tools.dance';
  }

  // Default to production API
  return process.env.REACT_APP_API_BASE_URL || 'https://api.tools.dance';
};

/**
 * API configuration constants
 */
export const API_BASE_URL = getApiBaseUrl();
export const API_VERSION = process.env.REACT_APP_API_VERSION || 'v1';

/**
 * Complete API base URL with version
 */
export const API_FULL_BASE_URL = `${API_BASE_URL}/api/${API_VERSION}/`;
